module.exports = __webpack_public_path__ + "img/preview.67bc0971.jpg";